import { configureStore } from '@reduxjs/toolkit';
import modalReducer from './features/modal/modalSlice';
import aktivnostiReducer from './features/aktivnosti/aktivnostiSlice';

export const store = configureStore({
    reducer: {
        aktivnosti: aktivnostiReducer,
        modal: modalReducer
    },
});